<template>
  <div class="content-wrapper">
    <sub-header :title="$t('menu.cashhero')" />
    <section class="content container-fluid">
      <div class="error-page">
        <h2 class="headline text-yellow">
          404
        </h2>
        <div class="error-content">
          <h3>
            <i class="fa fa-warning text-yellow" /> {{ $t('string.error_title') }}
          </h3>
          <p>
            We could not find the page you were looking for
          </p>
          <button
            @click="$router.push({name: 'dashboard'})"
            class="btn btn-primary btn-sm"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SubHeader from '@/components/SubHeader'

export default {
  name: 'Error',
  components: { SubHeader },
  metaInfo () {
    return {
      title: this.$t('string.404'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>
</style>
